module.exports = __webpack_public_path__ + "a4aba83ace1013a2f98dc6e581864d9c.png";